<template>
  <fade-left :show="showState" @hideModel="hideModelFn">
    <div class="comModals" :style="{ width: taskType == 0 ? '880px' : '740px' }">
      <div class="modal-body">
        <client ref="client" v-show="taskType == 1"></client>
        <server ref="server" v-show="taskType == 0"></server>
      </div>
      <div class="bottom">
        <!-- <div class="tips">
                    提示：以上网吧中未安装服务端的，关联网吧无效。
                </div>-->
        <div class="right">
          <a href="#" class="blue-btn" @click.stop.prevent="confirm">应用</a>
          <a href="#" class="default-btn" @click.stop.prevent="cancle">取消</a>
        </div>
      </div>
    </div>
  </fade-left>
</template>
<script>
import FadeLeft from "_c/modals/fadeLeft";
import client from "./client";
import server from "./server";
import { relatedBar } from "@/requests/threeTierMission";
import { mapActions } from "vuex";
export default {
  name: "Modal",
  components: {
    FadeLeft,
    client,
    server
  },
  data () {
    return {
      showState: false,
      taskId: 0,
      taskType: 0,
      successFn: "",
      clientTimer: null,
      serverTimer: null
    };
  },
  mounted () {
    window.$modal.relatedBar = {};
    window.$modal.relatedBar.show = (taskId, taskType) => {
      this.taskId = taskId;
      this.taskType = taskType;
      this["user/actionUpdateBarGroupList"]();
      this["serverLabel/actionUpdateLabelInfo"]();
      return new Promise(resolve => {
        this.init(() => {
          resolve(true);
        });
      });
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27)
        {
          self.hideModelFn();
        }
      })
    })
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    hideModelFn (val) {
      this.showState = val
    },
    ...mapActions([
      "serverLabel/actionUpdateLabelInfo",
      "user/actionUpdateBarGroupList"
    ]),
    clearTimer () {
      clearTimeout(this.clientTimer);
      clearTimeout(this.serverTimer);
    },
    // 初始化信息
    init (fn) {
      this.clearTimer()
      if (this.taskType == 1)
      {
        this.$refs.client.task = this.taskId;
        this.$refs.client.getClientTableList(1);
        this.timerClientFun();
      } else
      {
        this.$refs.server.task = this.taskId;
        this.$refs.server.getServerTableList(1);
        this.timerServerFun();
      }
      this.showState = true;
      this.successFn = fn;
    },
    timerClientFun () {
      clearTimeout(this.clientTimer);
      this.clientTimer = setTimeout(async () => {
        await this.$refs.client.getClientTableList(1);
        this.timerClientFun();
      }, 60000);
    },
    timerServerFun () {
      clearTimeout(this.serverTimer);
      this.serverTimer = setTimeout(async () => {
        await this.$refs.server.getServerTableList(1);
        this.timerServerFun();
      }, 60000);
    },
    async confirm () {
      if (this.taskType == 1)
      {
        let res = await relatedBar({
          taskId: this.taskId,
          list: this.$refs.client.allCheck
            ? []
            : this.$refs.client.barIdList
        });
        if (res.code === 200)
        {
          this.showState = false;
          this.clearTimer()
          this.successFn();
        } else
        {
          window.$Message.show({
            title: "关联网吧",
            type: "error",
            msg: res.msg
          });
        }
      } else
      {
        let res = await relatedBar({
          list: this.$refs.server.allCheck
            ? []
            : this.$refs.server.barIdList,
          taskId: this.taskId
        });
        if (res.code === 200)
        {
          this.showState = false;
          this.clearTimer()
          this.successFn();
        } else
        {
          window.$Message.show({
            title: "关联网吧",
            type: "error",
            msg: res.msg
          });
        }
      }
    },
    cancle () {
      this.showState = false;
      this.clearTimer()
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.comModals {
  color: $black-1;
  width: 880px;
  margin: 0 auto;
}

.modal-body {
  padding: 10px;
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;
}

.bottom {
  overflow: hidden;
  text-align: right;
  padding-right: 30px;
  padding-left: 30px;
  height: 70px;

  a {
    min-width: 60px;
    text-align: center;
    margin-left: 10px;
  }

  .tips {
    color: tomato;
    float: left;
    height: 30px;
    line-height: 30px;
  }

  .right {
    float: right;
  }
}
</style>
